<template>
  <div>
    <VWidget
      v-if="order.customer.customer_id"
      :title="$t('Customer')"
      class="mb-4"
    >
      <v-layout
        slot="widget-content"
        row
        wrap
        class="ma-2"
      >
        <v-flex
          xs12>
          <div
            v-if="order.customer.firstname"
            class="info--text subheading mb-3"
          >
            <router-link
              :to="{
                name: 'single_customer',
                params: { id: order.customer.customer_id }
              }"
            >
              {{ order.customer.firstname }} {{ order.customer.lastname }}
            </router-link>
            <div class="info--text subheading">
              {{ order.customer.email }}
            </div>
            <div class="info--text subheading">
              {{ order.customer.telephone | telephone }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </VWidget>
    <VWidget
      v-if="order.customer.guest_id"
      :title="$t('Customer (guest)')"
      class="mb-4"
    >
      <v-layout
        v-if="order.customer.firstname"
        slot="widget-content"
        row
        wrap
        class="ma-2"
      >
        <v-flex xs12>
          <div class="info--text subheading mb-3">
            <div>
              {{ order.customer.firstname }} {{ order.customer.lastname }}
            </div>
            <div class="info--text subheading">
              {{ order.customer.email }}
            </div>
            <div class="info--text subheading">
              {{ order.customer.telephone | telephone }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </VWidget>
    <VWidget
      :title="$t('Shipping Address')"
      class="mb-4"
    >
      <div
        v-if="order.customer.customer_id"
        slot="widget-header-action"
      >
        <v-btn
          flat
          class="text--secondary text-capitalize"
          @click="$emit('change-shipping-address')"
        >
          {{ $t('Change') }}
        </v-btn>
      </div>
      <order-address-view
        v-if="order.shipping_address"
        slot="widget-content"
        :address="order.shipping_address"
      />
    </VWidget>
    <VWidget
      :title="$t('Billing Address')"
      class="mb-4"
    >
      <div
        v-if="order.customer.customer_id"
        slot="widget-header-action"
      >
        <v-btn
          flat
          class="text--secondary text-capitalize"
          @click="$emit('change-billing-address')"
        >
          {{ $t('Change') }}
        </v-btn>
      </div>
      <order-address-view
        v-if="order.billing_address"
        slot="widget-content"
        :address="order.billing_address"
      />
    </VWidget>
  </div>
</template>

<script>

import OrderAddressView from '@/modules/Orders/components/OrderAddressView'
export default {
  name: 'OrderDraftCustomer',
  components: { OrderAddressView },
  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
